const tabs = () => {

  /**
   * Initialize tab capabilities.
   */
  const init = () => {

    const tabbed = document.querySelector( '[data-tabs]' ) as HTMLElement
    if ( ! tabbed ) return false
    const isCollapsed = tabbed.dataset.collapse !== undefined ? true : false
    const forceHeight = tabbed.dataset.forceHeight === 'false' ? false : true
    // const revealFirstTab = isCollapsed ? false : tabbed.dataset.revealFirst ? true : false
    const revealFirstTab = tabbed.dataset.revealFirst

    const tablist = tabbed.querySelector( 'ul' )
    const tabs = tablist?.querySelectorAll( 'a' )
    const panels = tabbed.querySelectorAll( '[data-tab]' ) as NodeListOf<HTMLElement>

    if ( tabs && panels && tablist ) {
      tablist.setAttribute( 'role', 'tablist' )
      setupTabs( tabs, panels, tablist, isCollapsed )
      setupSemantics( tabs, panels )
      if ( forceHeight ) setMinHeight( panels )
      revealFirst( tabs, panels )
    }

    return true

  }

  const setMinHeight = ( panels: NodeListOf<HTMLElement> ) => {
    const vw = Math.max( document.documentElement.clientWidth || 0, window.innerWidth || 0 )
    if ( vw < 1024 ) return false
    const heightValues: number[] = []
    panels.forEach( panel => {
      panel.hidden = false
      const height = window.getComputedStyle( panel ).getPropertyValue( 'height' )
      const heightValue = Number( height.replace( 'px', '' ) )
      heightValues.push( heightValue )
      panel.hidden = true
    } )
    const maxHeight = Math.max.apply( null, heightValues )
    panels.forEach( panel => panel.style.minHeight = `${maxHeight}px` )
    return true
  }

  /**
   * Add semantics are remove user focusability for each tab
   */
  const setupTabs = (
    tabs: NodeListOf<Element>,
    panels: NodeListOf<HTMLElement>,
    tablist: HTMLUListElement,
    isCollapsed = false
  ) => {
    tabs.forEach( ( tab, i ) => {
      tab.setAttribute( 'role', 'tab' )
      tab.setAttribute( 'id', `tab${i + 1}` )
      tab.setAttribute( 'tabindex', '-1' )
      tab.parentElement?.setAttribute( 'role', 'presentation' )

      tab.addEventListener( 'click', e => {
        e.preventDefault()
        const currentTab = tablist.querySelector( '[aria-selected]' ) as HTMLElement
        const target = e.currentTarget as HTMLElement
        if ( currentTab && e.currentTarget && e.currentTarget !== currentTab ) switchTab( tabs, panels, currentTab, target )
        if ( e.currentTarget === currentTab && isCollapsed ) {
          const panel = document.querySelector( `[aria-labelledby="${currentTab.id}"]` ) as HTMLElement
          panel.hidden = ! panel.hidden
        }
      } )

      // Handle keydown events for keyboard users
      tab.addEventListener( 'keydown', e => {
      // Get the index of the current tab in the tabs node list
        const index = Array.prototype.indexOf.call( tabs, e.currentTarget )
        // Work out which key the user is pressing and
        // Calculate the new tab's index where appropriate
        const target = e.currentTarget as HTMLElement
        const event = e as KeyboardEvent
        const dir = event.key === 'ArrowLeft' ? index - 1 : event.key === 'ArrowRight' ? index + 1 : event.key === 'ArrowDown' ? 'down' : null
        if ( dir !== null ) {
          e.preventDefault()
          dir === 'down' ? panels[i].focus() : tabs[dir] ? switchTab( tabs, panels, target, tabs[dir] as HTMLElement ) : void 0
        }
      } )
    } )
  }

  const setupSemantics = ( tabs: NodeListOf<Element>, panels: NodeListOf<HTMLElement> ) => {
    panels.forEach( ( panel, i ) => {
      panel.setAttribute( 'role', 'tabpanel' )
      panel.setAttribute( 'tabindex', '-1' )
      panel.setAttribute( 'aria-labelledby', tabs[i].id )
      panel.hidden = true
    } )
  }

  /**
   * Initially activate the first tab and reveal the first tab panel
   */
  const revealFirst = ( tabs: NodeListOf<Element>, panels: NodeListOf<HTMLElement> ) => {
    tabs[0].removeAttribute( 'tabindex' )
    tabs[0].setAttribute( 'aria-selected', 'true' )
    panels[0].hidden = false
  }

  // The tab switching function
  const switchTab = ( tabs: NodeListOf<Element>, panels: NodeListOf<HTMLElement>, oldTab: HTMLElement|null = null, newTab: HTMLElement|null = null ) => {
    if ( oldTab ) {
      oldTab.removeAttribute( 'aria-selected' )
      oldTab.setAttribute( 'tabindex', '-1' )
      // Make the old tab hidden.
      panels.forEach( panel => panel.hidden = true )
    }
    if ( newTab ) {
      newTab.focus()
      // Make the active tab focusable by the user (Tab key).
      newTab.removeAttribute( 'tabindex' )
      // Set the selected state.
      newTab.setAttribute( 'aria-selected', 'true' )
      // Make the new tab visible.
      const index = Array.prototype.indexOf.call( tabs, newTab )
      panels[index].hidden = false
    }
  }

  return {
    init
  }

}

export default tabs

